import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const articles = document.querySelectorAll('.block-article-list-swiper');
articles.forEach((articleElement, index) => {
    articleElement.classList.add(`block-article-list-swiper-${index}`);

    const swiper = new Swiper(`.block-article-list-swiper-${index}`, {
        modules: [Navigation, Pagination],
        a11y: true,
        speed: 400,
        loop: false,
        centeredSlides: false,

        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30
            }
        },
        slideClass: 'swiper-slide',
        navigation: {
            addIcons: false,
            nextEl: `.block-article-list-swiper-${index} .swiper-button-next`,
            prevEl: `.block-article-list-swiper-${index} .swiper-button-prev`,
        },
        pagination: {
            el: `.block-article-list-swiper-${index} .swiper-pagination`,
            type: 'bullets',
            clickable: true
        },
    });
});